<template>
  <div v-if="tabs.length" class="clients-section">
    <!-- Шапка раздела по прототипу: заголовок «Клиенты», справа — главное действие вкладки -->
    <div class="d-flex align-center flex-wrap mb-2" style="gap: 12px">
      <h1 class="font-lg" style="flex: 1">Клиенты</h1>
      <slot name="actions" />
      <v-btn v-if="actionText && (!actionPermission || $store.getters['auth/isAllowed'](actionPermission))" color="primary" @click="$emit('action')">
        {{ actionText }}
      </v-btn>
    </div>
    <!-- Активную вкладку задаём явно по имени роута: каждая страница раздела монтирует свои вкладки заново,
         и автоопределение Vuetify по классу router-link на свежем экземпляре срабатывает не с первого перехода.
         Без exact: у списков в адресе бывают параметры (?page=1), точное совпадение снимало подсветку. -->
    <v-tabs :value="$route.name" class="clients-section-tabs mb-4" slider-size="3" optional>
      <v-tab v-for="tab in tabs" :key="tab.to" :tab-value="tab.to" :to="{ name: tab.to }">{{ tab.title }}</v-tab>
    </v-tabs>
  </div>
</template>

<script>
import { allowedClientsSectionTabs } from '@/common/constants/clientsSection';

// Вкладки раздела «Клиенты». Только у админа: у корпа и менеджера свои пункты меню.
export default {
  name: 'ClientsSectionTabs',
  props: {
    // Главное действие открытой вкладки, например «+ Создать корп. клиента»
    actionText: { type: String, default: '' },
    actionPermission: { type: String, default: '' },
  },
  computed: {
    tabs() {
      return allowedClientsSectionTabs(this.$store);
    },
  },
};
</script>

<style scoped lang="scss">
// Вкладки как в прототипе: обычный регистр, полужирные, неактивные — серые
::v-deep .v-tab {
  text-transform: none;
  letter-spacing: normal;
  font-weight: 600;
  font-size: 15px;
}
</style>
